module.exports = __webpack_public_path__ + "static/img/cac.d9275f3d.png";